
    /**
    * 商家入驻 名称校验
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiCheckSupplyName11900 {
  /**
   * 名称
   */
  companyName: string | number;
}
    export class IResApiCheckSupplyName11900 {
  code: number;
  data: {
    /**
     * 0 未入驻  1 已入驻
     */
    exist: number;
  };
  message: string;
  success: boolean;
}
    const http: Serve<IReqApiCheckSupplyName11900, IResApiCheckSupplyName11900> = (data?) =>  request({
      method: 'GET',
      url: '/api/check/supplyName',
      params: data
    }) 
    export default http